module.exports = __webpack_public_path__ + "img/bannerblackblue.fe04de35.png";